import React, { useEffect, useState } from "react";
import Loading from "../../../Common/Components/Loading";
import { GetData } from "./Components/Services";
import { Fragment } from "react";
import DataTable from "../../../Common/Components/DataTable";
import { useNavigate } from "react-router";
import TicketItem from "../../../../App/Panel/Ticketing/TicketItem";
import { ToTimeJalali } from "../../../Common/Function";

export default function List({ isApp, reloadPage }) {
  const navigate = useNavigate();
  const initialState = {
    loading: true,
    data: {
      data: null,
      current_page: null,
    },
  };

  const [state, setState] = useState(initialState);
  useEffect(() => {
    hanlder();
  }, [reloadPage]);

  const hanlder = (pageNumber = 1, limit) => {
    setState({ ...state, loading: true });
    GetData(pageNumber, limit).then(result => {
      setState({
        loading: false,
        data: result,
      });
    });
  };

  const getStatus = (data) => {
    switch (data) {
      case "answerd": return "پاسخ داده شده"
      case "waiting": return "در حال انتظار"
    }
  }

  return (
    <Fragment>
      {console.log(state)}
      {isApp &&
        <>
          <p className="mb-3">لیست تیکت ها </p>
          {state.loading
            ? <Loading height={"50px"} count={3} col={"12"} />
            : state?.data?.data.length > 0
              ? state.data.data.map(item => (
                <TicketItem number={item.id} title={item.title}
                  date={ToTimeJalali(item.created_at)}
                  status={getStatus(item.status)}
                  clickEV={() => navigate(`/panel/ticketing/List/${item.id}`)}
                />
              ))
              : <p className="text-center mt-3 bg-transparent">  تیکتی وجود ندارد !   </p>
          }
        </>
      }


      {!isApp &&
        <DataTable
          loading={state.loading}
          needSearch={true}
          heads={[
            {
              title: "عنوان درخواست",
              key: "title",
            },
            {
              title: "وضعیت درخواست",
              key: "status",
              type: "enum",
              enum: {
                answerd: "پاسخ داده شده",
                waiting: "در حال انتظار",
              },
            },
            {
              title: "نوع کاربر",
              key: "role",
              type: "enum",
              enum: {
                user: "کاربر",
                manager: "مدیر مجموعه",
                classmanager: "برگزار کننده کلاس",
              },
            },
            {
              title: "تاریخ ایجاد",
              key: "created_at",
              type: "date",
              timetype: "date-time",
            },
          ]}
          textEmpty=" درخواستی  ثبت نشده"
          list={state.data && state.data.data}
          data={state.data}
          currentPage={state.data && state.data.current_page}
          function={hanlder}
          header=" لیست درخواست ها"
          links={[
            {
              function: selected => {
                navigate(
                  `/User/ticketing/List/${state.data &&
                  state.data.data.filter(item => item.id == selected)[0].id
                  }`
                );
              },
              color: "success",
              size: "col-md-2",
              html: "مشاهده",
              multi: false,
              type: "show",
              main: true,
            },
          ]}
        />
      }
    </Fragment>
  );
}
